import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  get_industry_templates_data,
  get_recent_project_data,
  get_recent_tutorials_data,
} from '../../redux/Slice/homeSlice';
import {
  CardLayout,
  DashboardContainer,
} from '../../components/ui/UtilsLayout';
import ChatInput from '../../components/mcp/McpInputBox';

const Dashboard = () => {
  const [showAll, setShowAll] = useState(''); // State to track expanded sections
  const dispatch = useDispatch();
  // const [showChatInterface, setShowChatInterface] = useState(false);

  //

  const { showChatInterface } = useSelector((state) => state.data);

  // Extract data from Redux store
  const { industry_templates, recent_project, recent_tutorials } = useSelector(
    (state) => state.data
  );

  // Handle URL parameters (e.g., user authentication)

  // Fetch required data when the component mounts
  useEffect(() => {
    dispatch(get_recent_project_data());
    dispatch(get_industry_templates_data());
    dispatch(get_recent_tutorials_data());
  }, []);

  // Define sections dynamically for cleaner code
  const sections = [
    {
      title: 'Recent',
      buttonText1: 'View all',
      buttonText2: 'View less',
      arr: recent_project,
      showName: 'project_name',
    },
    {
      title: 'Industry Templates',
      buttonText1: 'Explore all',
      buttonText2: 'View less',
      arr: industry_templates,
      showName: 'project_name',
    },
    {
      title: 'Tutorials',
      buttonText1: 'Explore all',
      buttonText2: 'View less',
      arr: recent_tutorials,
      showName: 'project_name',
    },
  ];

  return (
    <DashboardContainer>
      {/* Render each section dynamically */}
      <ChatInput />
      {!showChatInterface && (
        <>
          {sections.map((section, idx) => (
            <CardLayout
              key={idx}
              title={section.title}
              showName={section.showName}
              showAll={showAll === idx + 1}
              showAllClick={() =>
                setShowAll((prev) => (prev === idx + 1 ? '' : idx + 1))
              }
              cards={section.arr}
              buttonText={
                showAll === idx + 1 ? section.buttonText2 : section.buttonText1
              }
            />
          ))}
        </>
      )}
    </DashboardContainer>
  );
};

export default Dashboard;
